export const UTM_SOURCES = {
    COLLEGE_FINDER: 'prep_college_finder',
    PC_NAVBAR: 'PC_prep'
};

export const NUDGE_REDIRECTIONS = {
    EVENTS_PAGE: 'https://yocket.com/events/2495?utm_source=prep_pricing'
};

export const X_SOURCE_APP = Object.freeze({
    SUPERTEST: 'supertest'
});
